import { Typography } from '@mui/material';
import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { H, V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import { Field, MeasurementField } from '../attributes';
import TypePreview from '../TypePreview';

type MeasurementAttributePreviewProps = {
    field: Field;
    onClick?: (Field) => void;
};

export default (props: MeasurementAttributePreviewProps) => {
    const { field, onClick } = props;
    const { theme } = useStyling();
    const measurementField = field as MeasurementField;

    return (
        <V onClick={onClick}>
            <TypePreview type={field.fieldType} />
            <EllipsisText text={measurementField.label} sx={{ width: '140px' }} />
            <EllipsisText
                text={measurementField.description}
                clampLines={2}
                sx={{
                    fontSize: 'smaller',
                    color: theme.palette.text.disabled,
                    width: '140px'
                }}
            />
            <H sx={{ gap: 1 }}>
                <Typography>Unit: {measurementField?.unit}</Typography>
                <Typography>Decimals: {measurementField.decimalsNumber}</Typography>
            </H>
        </V>
    );
};
